import { render, staticRenderFns } from "./ThirdPartyProvisionOfPersonalInformationTerm.vue?vue&type=template&id=73f63da1&"
import script from "./ThirdPartyProvisionOfPersonalInformationTerm.vue?vue&type=script&lang=ts&"
export * from "./ThirdPartyProvisionOfPersonalInformationTerm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports